// 新規のお申込み
import React, { useState, useEffect } from 'react';
import Heading from '../molecules/Heading';
import axios from '../axios';
import Annotation from '../atoms/Annotation';
import LoadingModal from '../molecules/LoadingModal';
import { isBrowserIOSSafari, isBrowserIpadSafari } from '../BrowserJudgment';
import { releaseBrowserBack } from '../BrowserBack';

interface Props {
  jacode?: string;
  is_corporate: boolean;
}

interface Documents {
  id: number;
  subject: string;
  file_name: string;
  description: string;
}

const NewApplication: React.FC<Props> = ({ jacode, is_corporate }) => {
  const [documents, setDocuments] = useState<Documents[]>([]);
  // ローディング画面表示制御
  const [is_loading, setIsLoading] = useState(false);

  useEffect(() => {
    getDocuments();
  }, []);

  // 表示するお手続き関係書類の取得
  const getDocuments = async () => {
    try {
      const response = await axios.get(
        `${location.origin}${process.env.MIX_MOCK_URL}/api/get_documents`
      );
      setDocuments(response.data);
    } catch (error) {
      console.error(error);
      alert(error.response.data.message);
    }
  };

  /**
   * お手続き関係書類のダウンロード
   *
   * @param id 該当ファイルの一意の値
   * @param file_name ファイル名
   */
  const downloadFile = (id: number, file_name: string) => {
    setIsLoading(true);
    try {
      //IOS端末かつsafariの場合、ブラウザバック禁止処理を解除してダウンロードしたファイルを表示後に元画面に戻れるようにする。
      if (isBrowserIOSSafari() || isBrowserIpadSafari()) {
        releaseBrowserBack();
      }

      //ファイルをダウンロードする。
      const url = `${location.origin}${process.env.MIX_MOCK_URL}/api/download_file?id=${id}`;
      const self_download_link = document.createElement('a');
      document.body.appendChild(self_download_link);
      self_download_link.download = `${file_name}`;
      self_download_link.href = url;
      self_download_link.click();
      self_download_link.remove();
      URL.revokeObjectURL(url);
    } catch (error) {
      console.error(error);
      alert('システムエラーが発生しました');
    }
    setIsLoading(false);
  };

  return (
    <div>
      <div className="content">
        <Heading label="ローンのお申込み" size="m" />
        <Heading label="新たに事前審査をお申込みされたい方" size="s" css_class="-base mt-3" />
        <div className="btn-box">
          <div className="btn-box_wrapper">
            {is_corporate ? (
              <a href="" className="btn-xl arrow-right disabled">
                新規事前審査申込
              </a>
            ) : (
              <a
                href={`${location.origin}${process.env.MIX_MOCK_URL}/mypage/set_r_type_id?r_type_id=2`}
                className="btn-xl arrow-right"
              >
                新規事前審査申込
              </a>
            )}
          </div>
        </div>
      </div>
      <div className="content">
        <Heading label="農業資金のご相談" size="m" />
        <Heading label="農業資金をご相談されたい方" size="s" css_class="-base mt-3" />
        <div className="btn-box">
          <div className="btn-box_wrapper">
            <a
              href={`${location.origin}${process.env.MIX_MOCK_URL}/mypage/set_r_type_id?r_type_id=1`}
              className="btn-xl arrow-right"
            >
              農業資金の借入相談
            </a>
          </div>
        </div>
      </div>
      {documents.length !== 0 && (
        <div className="content">
          <Heading label="お手続き関係書類" size="m" />
          <Annotation text="借入に関連する書類は以下からダウンロード可能です。" />
          <div className="btn-box">
            {documents.map((value, index) => {
              return (
                <div className="btn-box_wrapper mt-3" key={index}>
                  <a
                    className="btn-xl btn-download-icon"
                    onClick={() => downloadFile(value.id, value.file_name)}
                  >
                    {value.subject}
                  </a>
                  <span className="help-msg">{value.description}</span>
                </div>
              );
            })}
          </div>
        </div>
      )}
      <LoadingModal show={is_loading} />
    </div>
  );
};

export default NewApplication;
